/**
 * Project: bicc-ffvt-website-ui
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2023-02-13 00:40:37
 * License: MIT License
 */


export const schema = function () {
    return {

        // Query phrase
        q: {
            type: String,
            default: () => ''
        },

        // Taxonomy
        t: {
            type: Array,
            of: Number,
            default: () => []
        },

        // Research region
        r: {
            type: Array,
            of: Number,
            default: () => []
        },

        // Research countries
        c: {
            type: Array,
            of: Number,
            default: () => []
        },

        // Institutions
        i: {
            type: Array,
            of: Number,
            default: () => []
        },

        // Project type
        pt: {
            type: Array,
            default: () => []
        },

        // Research institution type
        rit: {
            type: Array,
            of: String,
            default: () => []
        },

        // Base institution type
        bit: {
            type: Array,
            of: String,
            default: () => ['research', 'finance']
        },

        // German state
        state: {
            type: String,
            default: () => ''
        },

        // Funding scope
        funding: {
            type: Array,
            of: String,
            default: () => []
        },

        // Relation
        rel: {
            type: String,
            default: () => 'institutions'
        },

        // Start year
        ys: {
            type: Number,
            default: () => null,
        },

        // End year
        ye: {
            type: Number,
            default: () => null,
        },

        limit: {
            type: Number,
            default: () => 10,
        },

    }
}

/**
 * @param URLSearchParams query
 * @returns Object
 */
export const toModel = function (query) {
    let model = {}
    const definition = schema()
    //
    for (const [key, def] of Object.entries(definition)) {
        if (query.has(key)) {
            let all = query.getAll(key)
            let val = null
            let type = def.type || (x => x)
            if (type === Array) {
                val = all.map(e => def.of(e))
            } else {
                const first = all[0] || null
                val = (first === null) ? null : type(first)
            }
            model[key] = val
        } else {
            model[key] = def.default()
        }
    }
    for (const [key, val] of query) {
        if (model[key] === undefined) {
            model[key] = val
        }
    }
    //
    return model
}

/**
 * @param Object model
 * @returns Array
 */
export const toSearch = function (model) {
    const pairs = []
    for (const k in model) {
        const v = model[k]
        if (Array.isArray(v)) {
            for (const x of v) {
                if (x !== '' && x !== null) {
                    pairs.push([k, x])
                }
            }
        } else if (v !== '' && v !== null) {
            pairs.push([k, v])
        }
    }
    return pairs
}
